import { FC, useState } from 'react';
import { Row } from '~/commonComponents';
import ConfirmPopup from '~/components/shared/ConfirmPopup';
import { ProfessionTypeCard } from './ProfessionTypeCard';
import { IProfessionOption } from './useSelectProfessionType';

interface ISelectProfessionTypePopupProps {
  professions: IProfessionOption[];
  onContinue: (professionCode: string) => void;
  onClose: () => void;
}

export const SelectProfessionTypePopup: FC<ISelectProfessionTypePopupProps> = ({
  professions,
  onContinue,
  onClose,
}) => {
  const [selectedCode, setSelectedCode] = useState<string | null>(null);

  const handleContinue = () => {
    if (selectedCode) {
      onContinue(selectedCode);
    }
  };

  return (
    // @ts-expect-error ConfirmPopup component still written in JavaScript
    <ConfirmPopup
      title="Select a Professional Type"
      description={'Start by selecting the professional type, then continue to the shift details'}
      showClosePopupIcon
      closePopup={onClose}
      leftButtonText="Go Back"
      leftButtonAction={onClose}
      rightButtonText="Continue"
      rightButtonAction={handleContinue}
      rightButtonDisabled={selectedCode === null}
      descriptionStyle={{ marginBottom: 24, width: 460 }}
      dismissiblePopup={false}
      modalStyle={{ minWidth: 614 }}
    >
      <Row gap={10} justifyContent="center" marginBottom={32} style={{ flexWrap: 'wrap' }}>
        {professions.map((profession) => (
          <ProfessionTypeCard
            key={profession.code}
            icon={profession.icon}
            label={profession.label}
            isSelected={selectedCode === profession.code}
            onClick={() =>
              setSelectedCode((prev) => (prev === profession.code ? null : profession.code))
            }
          />
        ))}
      </Row>
    </ConfirmPopup>
  );
};
